export const RUN_DB_CLIENTS_SCORING_MESSAGES = {
  SCORED_SUCCESS: 'All clients are scored successfully',
};


// WEBPACK FOOTER //
// ./src/features/score-card/constants/runDbClientsScoring.js